import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CalendarPeopleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="calendarPeople" ref={ref} {...props}>
    <path d="M17,3.18V2a.75.75,0,0,0-1.5,0V3h-4V2a.75.75,0,0,0-1.5,0V3h-4V2a.75.75,0,0,0-1.5,0V3.19A3.75,3.75,0,0,0,2,6.75V18a3.75,3.75,0,0,0,3.75,3.75.75.75,0,0,0,0-1.5A2.25,2.25,0,0,1,3.5,18V8.84H18.15v.88a.75.75,0,0,0,1.5,0v-3A3.74,3.74,0,0,0,17,3.18Zm1.11,4.16H3.5V6.75A2.25,2.25,0,0,1,5.75,4.5H15.9a2.25,2.25,0,0,1,2.25,2.25Zm-5.69,10a2.41,2.41,0,1,1,2.41-2.41A2.41,2.41,0,0,1,12.46,17.31Zm4,4.69H8.38a.49.49,0,0,1-.5-.49,3,3,0,0,1,3-3H14a3,3,0,0,1,3,3A.5.5,0,0,1,16.49,22Zm1.77-4.69a2.41,2.41,0,1,1,2.41-2.41A2.41,2.41,0,0,1,18.26,17.31ZM21.51,22H19.13c-.27,0-.4-.2-.5-.49a7.81,7.81,0,0,0-.53-1.25c-.32-.6-.46-.78-.46-.79a1,1,0,0,1-.24-.62.38.38,0,0,1,.43-.33H19a3,3,0,0,1,3,3A.49.49,0,0,1,21.51,22Z" />
  </Icon>
)) as IconWithRender;

CalendarPeopleIcon.displayName = 'CalendarPeopleIcon';
CalendarPeopleIcon.renderIcon = (props) => <CalendarPeopleIcon {...props} />;
export default CalendarPeopleIcon;
